import { render } from "./CardStar.vue?vue&type=template&id=4e73bcb2"
import script from "./CardStar.vue?vue&type=script&lang=js"
export * from "./CardStar.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Route\\Vue\\dashboard-tahsel-metronic\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__